// extracted by mini-css-extract-plugin
export default {"primeReactGridContainer":"IDMOGOwnership_primeReactGridContainer__lfszd"};